import { useState } from "react";
import { NavigationProvider } from "./navigationContext";
import { ThemeSettings } from "@kahunmedical/common-configuration";

export const useCreateNavigationStateProvider: () => NavigationProvider = () => {
  const [viewChanged, setViewChanged] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [retry, setRetry] = useState(false);
  const [themeSettings, setThemeSettings] = useState<ThemeSettings>({} as any);
  const [locale, setLocale] = useState<string>(null);

  return {
    viewChanged,
    setViewChanged,
    showRetry,
    setShowRetry,
    retry,
    setRetry,
    themeSettings,
    setThemeSettings,
    locale,
    setLocale,
  };
};
